import React from 'react';
var SendEmailIcon = function SendEmailIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "72",
    viewBox: "0 0 40 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration-Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.4477 19.8719C39.4477 9.19298 30.8055 0.550781 20.1266 0.550781C9.44774 0.550781 0.750488 9.19298 0.750488 19.8719C0.750488 27.7985 5.53948 34.5691 12.3101 37.5967L0.750488 71.4499H39.4477L27.8881 37.5967C34.6587 34.6242 39.4477 27.7985 39.4477 19.8719Z",
    fill: "#F9923C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.4479 72H0.750654C0.585516 72 0.420379 71.8899 0.310287 71.7798C0.200195 71.6147 0.200195 71.4495 0.255241 71.2844L11.6497 37.9266C4.71396 34.6239 0.200195 27.633 0.200195 19.8716C0.200195 8.91743 9.11763 0 20.0718 0C31.0259 0 39.9433 8.91743 39.9433 19.8716C39.9433 27.578 35.4846 34.6239 28.4938 37.8716L39.8883 71.2294C39.9433 71.3945 39.9433 71.5596 39.8332 71.7248C39.7231 71.8899 39.613 72 39.4479 72ZM1.5213 70.8991H38.6773L27.3378 37.7615C27.2277 37.4862 27.3929 37.211 27.613 37.1009C34.4387 34.0734 38.8424 27.3578 38.8424 19.8716C38.8974 9.52294 30.4754 1.10092 20.1268 1.10092C9.72313 1.10092 1.30111 9.52294 1.30111 19.8716C1.30111 27.3028 5.70478 34.0734 12.5305 37.1009C12.8057 37.211 12.9158 37.4862 12.8057 37.7615L1.5213 70.8991Z",
    fill: "#302C41"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.6315 13.9824C10.2186 13.9824 4.98926 19.8723 4.98926 19.8723C4.98926 19.8723 5.0443 19.8723 5.1544 19.8723C5.0443 19.8723 4.98926 19.8723 4.98926 19.8723C4.98926 19.8723 10.2186 25.7622 19.6315 25.7622C29.0443 25.7622 35.0443 19.8723 35.0443 19.8723C35.0443 19.8723 29.0993 13.9824 19.6315 13.9824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.0168 25.596C23.2094 25.596 25.7415 23.0089 25.7415 19.8713C25.7415 16.7336 23.1544 14.1465 20.0168 14.1465C16.8241 14.1465 14.292 16.7336 14.292 19.8713C14.292 23.0089 16.8791 25.596 20.0168 25.596Z",
    fill: "#302C41"
  })));
};
export default SendEmailIcon;